import { PropertyStatus } from '@dreamstack/web-graphql'
import type { ItemAvailability } from './RichMarkupTypes'

export const getItemAvailabilityForStatus = (
  status: number
): ItemAvailability => {
  const availabilty =
    status === PropertyStatus.FREE || status === PropertyStatus.FREE_STOP_AD
      ? 'InStock'
      : 'OutOfStock'
  return availabilty
}

export const MARKUP_IMAGE_UPPER_BOUND = 3
